<div class="configurations-group-container">
  <form nz-form [formGroup]="formGroup" (ngSubmit)="submitGroup()">
    <nz-row>
      <nz-col
        nzSm="24"
        nzMd="12"
        *ngFor="let field of fields"
        style="padding-inline: 10px"
      >
        <nz-form-item nz-row>
          <nz-form-label style="text-wrap: wrap" nz-col nzSpan="8">{{
            field.Title
          }}</nz-form-label>
          <nz-form-control nz-col nzSpan="16">
            <app-product-field
              [controlName]="field.Code.toString()"
              [field]="field"
              [formGroup]="formGroup"
            ></app-product-field>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>
    <div class="buttons">
      <button type="submit" nz-button nzType="primary">{{'Submit' | translate}}</button>
    </div>
  </form>
</div>
